<template>
  <div class="h-100" id="appContent" @dragstart="inDragStart($event)"  @drop="onDrop($event)" @dragover="onDragOver($event)" @dragleave="onDragLeave($event)">
    <div v-show="isDragOver" class="appContent__overlay">
        <div class="appContent__overlay--card">
          <p class="appContent__overlay--card--text">Déposez les fichiers ici</p>
        </div>
      </div>
    <router-view/>
    <!-- <color-switcher/> -->
  </div>
</template>
<script>
import ColorSwitcher from '@/components/Common/ColorSwitcher'
import { apiUrl } from "@/constants/config";
// import { getDirection } from '@/utils'
import { io } from "socket.io-client";
// const socket = io.connect(apiUrl);
export default {
  components: {
    ColorSwitcher
  },
  data(){
    return{
      isDragOver:false,
      endpoint:apiUrl
    }
  },
  mounted(){
    // query:`at=${this.currentAccount.hash}`,
    const socket = io.connect(this.endpoint);
    // socket.emit("message","get the fuck out")
  },
  methods:{
    inDragStart(event){
      event.preventDefault();
      this.isDragOver = false
    },
    onDrop(event){
      event.preventDefault();
      this.isDragOver = false
      if(this.$route.name == "patient"){
        this.$store.state.droppedFiles.patient = event.dataTransfer.files
      }
      else if(this.$route.name == "rdv"){
        this.$store.state.droppedFiles.rdv = event.dataTransfer.files
      }
      return
    },
    onDragOver(event){
      event.preventDefault();
      if(this.$route.name == "patient" && this.$store.state.isUploadTab){
        this.$store.state.droppedFiles = {
          patient:[],
          rdv:[]
        }
        this.isDragOver = true
      }
      else if(this.$route.name == "rdv" && this.$store.state.isUploadTab){
        this.$store.state.droppedFiles = {
          patient:[],
          rdv:[]
        }
        this.isDragOver = true
      }
      else{
        this.isDragOver = false
      }
    },
    onDragLeave(event){
      event.preventDefault();
      this.isDragOver = false
    }
  },
  beforeMount () {
    // const direction = getDirection()
    // if (direction.isRtl) {
    //   document.body.classList.add('rtl')
    //   document.dir = 'rtl'
    //   document.body.classList.remove('ltr')
    // } else {
      document.body.classList.add('ltr')
      document.dir = 'ltr'
      document.body.classList.remove('rtl')
    // }
  },
  async created(){
    const token = await this.checkToken();
    console.log("token",token)
    if (this.user == null && token) {
      console.log("localStorage.getItem('user')",localStorage.getItem('user'))
      this.$store.state.currentUser = JSON.parse(localStorage.getItem('user'));   
    }
  }
}
</script>
<style lang="scss">
.modal-right .modal-header {
  height:auto !important;
}
#appContent{
  .appContent__overlay{
    position: fixed;
    left:0;
    top:0;
    width:100%;
    height: 100%;
    background: rgba(242, 248, 255,0.9);
    z-index: 2000;
    padding: 15px;
    pointer-events: none;
    // opacity:0.2;
    *{
      pointer-events: none;
    }
    .appContent__overlay--card{
      height:100%;
      width:100%;
      border: 2px dashed #2B4D75;
      position:relative;
      border-radius: 5px;
      .appContent__overlay--card--text{
        position: absolute;
        left: 50%;
        top: 50%;
        margin: 0 auto;
        transform: translate(-50%,-50%);
        font-size:18px;
        color:#2B4D75;
        font-weight: 500;
      }
    }
  }
}
</style>
